export default function useURLQueryParams<T>() {
    const searchParams = new URLSearchParams(window.location.search);
    const desiredParams = {} as T;
    for (const [key, value] of searchParams.entries()) {
        desiredParams[key] = value;
    }
    return desiredParams as T;
}
